import { render, staticRenderFns } from "./ContentHome.vue?vue&type=template&id=21a27700&"
import script from "./ContentHome.vue?vue&type=script&lang=js&"
export * from "./ContentHome.vue?vue&type=script&lang=js&"
import style0 from "./ContentHome.vue?vue&type=style&index=0&id=21a27700&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21a27700')) {
      api.createRecord('21a27700', component.options)
    } else {
      api.reload('21a27700', component.options)
    }
    module.hot.accept("./ContentHome.vue?vue&type=template&id=21a27700&", function () {
      api.rerender('21a27700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/PageChild/ContentHome.vue"
export default component.exports